module.exports = __webpack_public_path__ + "img/key_info_gift.5b19087a.png";